import {
    FiCalendar,
    FiEdit2,
    FiFolder,
    FiDollarSign,
    FiTrendingUp,
    FiMinusCircle,
    FiTrash2,
} from "react-icons/fi";
import { formatCurrency } from "../../utils/formatCurrency";

const MESES = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre",
};

export default function PresupuestoTable({ data = [], onEdit, onDelete }) {
    return (
        <div className="table-wrap">
            <table className="table-app">
                <thead>
                <tr>
                    <th>Año</th>
                    <th>Mes</th>
                    <th>Categoría</th>
                    <th>Asignado</th>
                    <th>Ejecutado</th>
                    <th>Diferencia</th>
                    <th>Acción</th>
                </tr>
                </thead>
                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan="7" className="empty-state">
                            No hay presupuestos registrados
                        </td>
                    </tr>
                ) : (
                    data.map((row) => {
                        const diferencia =
                            Number(row.montoAsignado || 0) -
                            Number(row.montoEjecutado || 0);

                        return (
                            <tr key={row.idPresupuesto}>
                                <td>{row.anio}</td>

                                <td>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                            <FiCalendar size={15} />
                                            {MESES[Number(row.mes)] || row.mes}
                                        </span>
                                </td>

                                <td>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                            <FiFolder size={15} />
                                            {row.categoriaNombre || "-"}
                                        </span>
                                </td>

                                <td>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                            <FiDollarSign size={15} />
                                            {formatCurrency(row.montoAsignado || 0)}
                                        </span>
                                </td>

                                <td>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                            <FiTrendingUp size={15} />
                                            {formatCurrency(row.montoEjecutado || 0)}
                                        </span>
                                </td>

                                <td>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                            <FiMinusCircle size={15} />
                                            {formatCurrency(diferencia)}
                                        </span>
                                </td>

                                <td>
                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                        <button
                                            type="button"
                                            className="btn-secondary"
                                            onClick={() => onEdit(row)}
                                        >
                                            <FiEdit2 size={16} />
                                            Editar
                                        </button>

                                        <button
                                            type="button"
                                            className="btn-danger"
                                            onClick={() => onDelete(row)}
                                        >
                                            <FiTrash2 size={16} />
                                            Eliminar
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>
        </div>
    );
}